module.exports = __webpack_public_path__ + "img/yeszi.88a7937e.jpg";